import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_sandwich",
  "use": "svg_sandwich-usage",
  "viewBox": "0 0 22 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 17\" id=\"svg_sandwich\"><path d=\"M0 0h22v2.5H0V0ZM0 7h14v2.5H0V7ZM0 14h22v2.5H0V14Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol